"use strict";

exports.__esModule = true;
var _GithubButton = _interopRequireDefault(require("./GithubButton"));
exports.default = _GithubButton.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}